import { Flex } from '@chakra-ui/react';
import type { StackProps } from '@chakra-ui/react';

export const Stack = (props: StackProps) => {
  return <Flex direction='column' {...props} />;
};
